import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../Auth/AuthContext";
import { appStyleLogos, defaultLogos } from "./AppStyleLogos";
import SHA256 from "crypto-js/sha256";

export interface AppStyleLogo {
  login: string;
  app: string;
}

export interface OrganizationAppProps {
  orgName?: string;
  logo: AppStyleLogo;
  mspQueryString?: string;
}

export interface UseAppStylingReturn {
  appProps: OrganizationAppProps;
}

export const useAppStyling = (): UseAppStylingReturn => {
  const location = useLocation();
  const { search } = location;
  const {
    authState: { authenticated, organization },
  } = useContext(AuthContext);

  const getOrganizationAppProps = (): OrganizationAppProps => {
    let msp: string | undefined;
    let orgName: string | undefined;
    let mspQueryString: string | undefined;
    if (!authenticated) {
      const queryStringObj = queryString.parse(search);
      // query-string parse widens msp to string | string[] | null; at runtime
      // the msp query param is always a single string here.
      msp = queryStringObj.msp as string | undefined;
      orgName = msp;
      mspQueryString = `?msp=${msp}`;
    } else {
      msp = organization?.slug;
      orgName = organization?.name;
    }

    const hashedMsp = !!msp ? SHA256(msp).toString() : null;
    const logos = appStyleLogos;
    const hasOwnProps = hashedMsp !== null && !!logos?.[hashedMsp];
    return {
      orgName: hasOwnProps ? orgName : "Seemplicity", //Only if the org is whitelabel, we should use the org name
      logo: (hashedMsp !== null && logos?.[hashedMsp]) || defaultLogos,
      mspQueryString,
    };
  };

  const appProps = getOrganizationAppProps();

  return { appProps };
};
